import { gql } from '../../../apollo/__generated__';

export const ADMIN_EVENT_USERS = gql(`
  query AdminEventUsers($eventId: ID!, $previousEventId: ID) {
    eventUsers(eventId: $eventId, previousEventId: $previousEventId) {
      id
      email
      firstname
      nickname
      lastname
      studyTown
      studies
      folklore
      phone
      externalReferentFirstname
      externalReferentLastname
      externalReferentPhone
      birthdate
      food
      allergies
      medication
      hasCaution(eventId: $eventId)
      hasPaidTicket(eventId: $eventId)
      arrivalDay(eventId: $eventId)
      numberOfDays(eventId: $eventId)
      paidTicketAt(eventId: $eventId)
      hasPaidBedroom(eventId: $eventId)
      paidBedroomAt(eventId: $eventId)
      isNoAlcool(eventId: $eventId)
      isValidated(eventId: $eventId)
      userComment(eventId: $eventId)
      orgaComment(eventId: $eventId)
      joinedAt(eventId: $eventId)
      waitingListPosition(eventId: $eventId)
      maxSuperLikes(eventId: $eventId)
      pastEvents {
        id
        name
      }
    }
  }
`);
